












































import { Component, Prop, Mixins } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import { SnpMapping } from '@/services/connecteur'
import VTextFieldWithValidation from '@/components/Inputs/VTextFieldWithValidation.vue'
import snpMappingModule from '@/store/modules/SnpMappingModule'
import SNPSelect from '../Selects/SNPSelect.vue'

@Component({
  components: {
    SNPSelect,
    VTextFieldWithValidation
  }
})
export default class SnpMappingDisplay extends Mixins(BaseVue) {
  @Prop({ required: true })
  public snpMapping!: SnpMapping

  public async updateSnpMapping () {
    try {
      // @ts-ignore
      if (await this.$refs.form.validate()) {
        await snpMappingModule.updateSnpMapping(this.snpMapping)
        this.displayMessage(this.$t('snpMapping.updated'))
        this.closeModal()
      }
    } catch (error) {
      this.displayError(error)
    }
  }

  public get action () {
    return this.snpMapping.id
      ? this.$t('snpMapping.update')
      : this.$t('snpMapping.add')
  }

  public closeModal () {
    this.$emit('close')
  }
}
